import { render } from "./ViewFormAssociatedDevs.vue?vue&type=template&id=10be846c&scoped=true&ts=true"
import script from "./ViewFormAssociatedDevs.vue?vue&type=script&lang=ts"
export * from "./ViewFormAssociatedDevs.vue?vue&type=script&lang=ts"

import "./ViewFormAssociatedDevs.vue?vue&type=style&index=0&id=10be846c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10be846c"]])

export default __exports__